import { BaseTitle } from "@/components/atom/title/BaseTitle";
import { MantineDataTable } from "@/components/molecule/mantineDataTable/MantineDataTable";
import { DefectObject } from "@/components/organism/work/refactor/TempDefectInformBox";
import { COMMON_TEXT } from "@/constants/text";
import { useWorkDataStore } from "@/store/work.store";
import { Flex } from "@mantine/core";
import { ProductionPlansGet200ResponseRowsInnerWorksInner } from "@sizlcorp/sizl-api-document/dist/models";
import { MRT_ColumnDef } from "mantine-react-table";
import { useMemo } from "react";

const DefectLogs = Object.assign(
  {},
  {
    Title: BaseTitle,
    Table: MantineDataTable,
  }
);

export const DefectLogsBox = () => {
  const columns = useMemo<MRT_ColumnDef[]>(
    () => [
      {
        accessorKey: "defectName",
        header: COMMON_TEXT.COLUMN.DEFECT_NAME,
      },
      {
        accessorKey: "defectQuantity",
        header: COMMON_TEXT.COLUMN.DEFECT_QUANTITY,
      },
    ],
    []
  );

  const { workData } = useWorkDataStore((state) => ({
    workData: state.workData,
  }));
  const { work } = workData;

  const filterAndConvertDefectList = (
    defectList: {
      defectName: string;
      defectCode: string;
      defectQuantity: string;
      setUnitText: string;
    }[]
  ) => {
    return defectList
      .filter((defect) => defect.defectQuantity !== "0")
      .map(({ defectName, defectQuantity, setUnitText }) => ({
        defectName,
        defectQuantity: `${defectQuantity}${setUnitText}`,
      }));
  };

  const getCurrentDefectList = (
    work: ProductionPlansGet200ResponseRowsInnerWorksInner | undefined
  ) => {
    const defect = work?.currentLotSummary?.defect as DefectObject | undefined;
    if (!defect) return [];

    return Object.keys(defect).map((code) => ({
      defectName: defect[code]?.defectName ?? "",
      defectCode: code,
      defectQuantity: defect[code]?.defectQuantity ?? "",
      setUnitText: work?.item?.unitText ?? "",
    }));
  };

  const currentDefectList = getCurrentDefectList(work);
  const convertedDefectList = filterAndConvertDefectList(currentDefectList);

  return (
    <Flex display="flex" direction="column" gap="md" w={"100%"}>
      <DefectLogs.Table
        maxHeight={200}
        columns={columns}
        data={convertedDefectList}
      />
    </Flex>
  );
};
